import { instanceOEF, segundaVersaoOEF } from './api'

export const postRenovacaoPlanoAPI = dadosRenovacao => {
  return instanceOEF.post(
    `${segundaVersaoOEF}/renovacao`,
    { ...dadosRenovacao }
  )
}
